var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96875 0.609375C5.96094 0.609375 2 3.28125 2 7.60547C2 10.3555 3.54688 11.918 4.48438 11.918C4.87109 11.918 5.09375 10.8398 5.09375 10.5352C5.09375 10.1719 4.16797 9.39844 4.16797 7.88672C4.16797 4.74609 6.55859 2.51953 9.65234 2.51953C12.3125 2.51953 14.2812 4.03125 14.2812 6.80859C14.2812 8.88281 13.4492 12.7734 10.7539 12.7734C9.78125 12.7734 8.94922 12.0703 8.94922 11.0625C8.94922 9.58594 9.98047 8.15625 9.98047 6.63281C9.98047 4.04688 6.3125 4.51563 6.3125 7.64063C6.3125 8.29688 6.39453 9.02344 6.6875 9.62109C6.14844 11.9414 5.04688 15.3984 5.04688 17.7891C5.04688 18.5273 5.15234 19.2539 5.22266 19.9922C5.35547 20.1406 5.28906 20.125 5.49219 20.0508C7.46094 17.3555 7.39062 16.8281 8.28125 13.3008C8.76172 14.2148 10.0039 14.707 10.9883 14.707C15.1367 14.707 17 10.6641 17 7.01953C17 3.14063 13.6484 0.609375 9.96875 0.609375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.609375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.5eb954d9e548e721eb44ad4ab05980db.svg";
export { ForwardRef as ReactComponent };